import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function HeroSection() {
  return <section id="hero" className="hero-bg relative min-h-screen flex flex-col items-center justify-center overflow-hidden" data-id="element-18">
      {/* Decorative Brand Elements (Deck style) */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{
      zIndex: 0
    }} data-id="element-19">
        {/* Neon Rectangle */}
        <motion.div className="absolute bottom-0 left-[10%] md:left-[20%] w-48 md:w-80 h-48 md:h-80 bg-accent" initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-20" />

        {/* Dotted Circles */}
        <div className="absolute bottom-[-20%] right-[-10%] w-[600px] md:w-[1000px] h-[600px] md:h-[1000px] opacity-30" data-id="element-21">
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-22">
            <defs data-id="element-23">
              <pattern id="dotPattern" x="0" y="0" width="12" height="12" patternUnits="userSpaceOnUse" data-id="element-24">
                <circle cx="2" cy="2" r="1.5" fill="#FFFFFF" opacity="0.8" data-id="element-25" />
              </pattern>
              <mask id="circleMask1" data-id="element-26">
                <circle cx="50%" cy="50%" r="35%" fill="white" data-id="element-27" />
              </mask>
              <mask id="circleMask2" data-id="element-28">
                <circle cx="25%" cy="70%" r="25%" fill="white" data-id="element-29" />
              </mask>
            </defs>
            <rect width="100%" height="100%" fill="url(#dotPattern)" mask="url(#circleMask1)" data-id="element-30" />
            <rect width="100%" height="100%" fill="url(#dotPattern)" mask="url(#circleMask2)" data-id="element-31" />
          </svg>
        </div>
      </div>

      {/* Giant decorative N */}
      <motion.div aria-hidden="true" className="absolute inset-0 flex items-center justify-center pointer-events-none select-none" style={{
      zIndex: 0
    }} animate={{
      x: [0, 18, 0],
      y: [0, -14, 0]
    }} transition={{
      duration: 18,
      ease: 'easeInOut',
      repeat: Infinity,
      repeatType: 'loop'
    }} data-id="element-32">
        <span className="font-serif leading-none" style={{
        fontSize: 'clamp(280px, 42vw, 700px)',
        color: 'rgba(229, 255, 0, 0.04)',
        userSelect: 'none'
      }} data-id="element-33">
          N
        </span>
      </motion.div>

      {/* Content */}
      <motion.div className="relative z-10 text-center px-6 md:px-12 max-w-5xl mx-auto" variants={containerVariants} initial="hidden" animate="visible" data-id="element-34">
        {/* Label */}
        <motion.p variants={itemVariants} className="font-sans text-xs font-medium tracking-[0.25em] uppercase text-accent mb-8" data-id="element-35">
          Power of N Ventures
        </motion.p>

        {/* Main heading */}
        <motion.h1 variants={itemVariants} className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] text-text-primary leading-[1.05] mb-8" data-id="element-36">
          I back original thinkers at{' '}
          <em className="italic text-text-primary" data-id="element-37">day zero.</em>
        </motion.h1>

        {/* Sub-text */}
        <motion.div variants={itemVariants} className="flex flex-col gap-6 max-w-2xl font-sans text-base sm:text-lg md:text-xl text-text-muted leading-relaxed text-left" data-id="element-38">
          <p data-id="element-39">
            I'm often the first text and first capital in — working alongside
            you as your idea becomes a company.
          </p>
          <p data-id="element-40">
            No process—relationships with founders who see something earlier
            than others do and build it.
          </p>
          <p data-id="element-41">
            I invest $500K to $1M — before anyone else — and you join a network
            of founders and operators who've done it before.
          </p>
        </motion.div>
      </motion.div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10" data-id="element-42">
        <a href="#thesis" aria-label="Scroll down" className="block" data-id="element-43">
          <ChevronDownIcon className="scroll-indicator text-text-muted" size={20} strokeWidth={1.5} data-id="element-44" />
        </a>
      </div>
    </section>;
}